import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { AppService } from "./app.service";

@Injectable()
export class AuthInternalConsultantGuard implements CanActivate {
  constructor(public appService: AppService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.appService.getUserProfile().then(user => {
      if (user.role === "ACCINTCONS") {
        return true;
      }
      this.router.navigate(["/intconslanding"]);
      return false;
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/auth-internal-consultant-guard.ts